import { store } from "../../../../app/store";
export const handleUpdateWorkbook = (updateWorkbook) => {
  // Get the current Redux state
  const currentState = store.getState().Workbook.present;
  const body = {
    _id: currentState._id,
    draftId: currentState.draftId,
    icon: null,
    name: currentState.name,
    createdOn: currentState.createdOn,
    commonFilters: currentState.commonFilters,
    calculatedFields: currentState.calculatedFields,
    folderId: currentState.folderId,
    hierarchy: currentState.hierarchy,
    sheetsData: currentState.sheets,
    selectedSheetId: currentState.selectedSheetId,
    dataSources: currentState.dataSources,
  };
  // console.log(body);
  updateWorkbook(body);
};
